export default {"src":"/_next/static/media/home-keeping-it-green-icon.655a0614.svg","height":62,"width":70,"blurWidth":0,"blurHeight":0};